export default {
      id: "chevron-down-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#chevron-down",
      toString: function () {
        return this.url;
      }
    }